import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=aa62a47c&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=aa62a47c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa62a47c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa62a47c')) {
      api.createRecord('aa62a47c', component.options)
    } else {
      api.reload('aa62a47c', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=aa62a47c&scoped=true", function () {
      api.rerender('aa62a47c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/platformManage/user/detail.vue"
export default component.exports